export const SPACECRAFT_METADATA = [
  {
    match: /^ISS \(ZARYA\)$/,
    class: "International Space Station",
    icon: {
      name: "iss.svg",
      scale: 0.06,
    },
  },
  {
    match: /^(CREW DRAGON|AXIOM)/,
    class: "SpaceX Crew Dragon",
    icon: {
      name: "dragon.svg",
      scale: 0.6,
    },
  },
  {
    match: /^DRAGON CRS-/,
    class: "SpaceX Cargo Dragon",
    icon: {
      name: "dragon.svg",
      scale: 0.6,
    },
  },
  {
    match: /^STARLINER/,
    class: "Boeing CST-100 Starliner",
    icon: {
      name: "starliner.png",
      scale: 0.15,
    },
  },
  {
    match: /^SOYUZ-MS/,
    class: "Soyuz Spacecraft",
    icon: {
      name: "soyuz.svg",
      scale: 0.045,
    },
  },
  {
    match: /^PROGRESS-MS/,
    class: "Progress Freighter",
    icon: {
      name: "soyuz.svg",
      scale: 0.045,
    },
  },
  {
    match: /^CSS/,
    class: "Chinese Space Station",
    icon: {
      name: "tiangong_1.svg",
      scale: 0.08,
    },
  },
  {
    match: /^TIANZHOU/,
    class: "Chinese Freighter",
    icon: {
      name: "shenzhou.svg",
      scale: 0.12,
    },
  },
  {
    match: /^SHENZHOU/,
    class: "Chinese Spacecraft",
    icon: {
      name: "shenzhou.svg",
      scale: 0.12,
    },
  },
  {
    match: /^TDRS [1-7]$/,
    class: "TDRS Gen. 1",
    icon: {
      name: "TDRS_gen1.png",
      scale: 0.2,
    },
  },
  {
    match: /^TDRS ([8-9]|10)$/,
    class: "TDRS Gen. 2",
    icon: {
      name: "TDRS_gen2.png",
      scale: 0.2,
    },
  },
  {
    match: /^TDRS 1[1-4]$/,
    class: "TDRS Gen. 1",
    icon: {
      name: "TDRS_gen3.png",
      scale: 0.2,
    },
  },
  // Has to be the last one, always matches (fallback)
  {
    match: /.*/,
    class: "Other Satellite",
    icon: {
      name: "satellite.svg",
      scale: 0.16,
    }
  }
]